import moment from 'moment-timezone';

export const getDailySeedDate = (): Date => {
  const now = moment().tz('America/New_York');
  const adjusted = now.hour() < 3 ? now.subtract(1, 'day') : now;
  return adjusted.startOf('day').toDate(); // Strip time just in case
};

export const getSeedString = (sequenceNumber: number): string => {
  const date = getDailySeedDate();
  return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${sequenceNumber}`;
};
